import React, { useState, useEffect } from "react";
import "../../components/AddPetBreed/AddPetBreed.css";
import axios from "axios";

const AddPetBreed = ({tokenStorage,openAddProfile,setOpenAddProfile}) => {

  const [petTypeResponse, setPetTypeResponse] = useState([]);
  const baseAPI = process.env.REACT_APP_API_URL;
  const [formData, setFormData] = useState({
    ID: 0,
    PetTypeID: "",
    PetBreedType1: "",

    createdBy: "Vishal",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // alert(formData.ID);
    // alert(PetTypeID);
    try {
      const storedToken = JSON.parse(localStorage.getItem("token"));
      // Make a POST request to your API endpoint
      const response = await axios.post(
        `${baseAPI}adminpost/AddPetBreed`,
        formData, // Send formData as the request body
        {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        }
      );


      // Optionally, reset the form
      setFormData({

        PetTypeID: "",
        PetBreedType1: "",

        createdBy: "Vishal",
      });
      tokenStorage();
      setOpenAddProfile (!openAddProfile); 
    } catch (error) {
      // Handle errors (e.g., show an error message)
      console.error("Error posting data:", error);
    }
  };

  useEffect(() => {
    const storedToken = JSON.parse(localStorage.getItem("token"));


    if (storedToken) {
      axios
        .get(
          `${baseAPI}adminget/GEPetType?PetType=0`,
          {
            headers: {
              Authorization: `Bearer ${storedToken}`,
            },
          }
        )
        .then((response) => {
          //console.log(response.data.data);
          setPetTypeResponse(response.data.data);

        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });
    }
  }, []);

  const handleSelectChange = (event) => {    
    formData.PetTypeID = event.target.value;
  };

  return (
    <div className="container-fluid">
      <br />

      <div className="petBreedDetail">
        <div className="petBreed-form" >
          <table style={{ width: "100%" }}>
            <tr className="space">
              <td colSpan={3}></td>
            </tr>
            <tr className="tableHeading">
              <td>Pet Type*</td>
              <td>Pet Breed</td>
              <td>Status</td>
            </tr>

            <tr>
              <td>
                <select
                  name="id"
                  onChange={handleSelectChange}
                  style={{ height: "29px" }}
                >
                  <option value="">Select an option</option>
                  {petTypeResponse.map((item) => (
                    <option value={item.id}>
                      {item.petType}
                    </option>
                  ))}
                </select>
              </td>
              <td>
                <input
                  type="text"
                  name="PetBreedType1"
                  value={formData.PetBreedType1}
                  placeholder="Please Enter*"
                  onChange={handleChange} 
                />
              </td>
              <td style={{ color: "#28A745" }}>
                <input type="text" placeholder="Please Enter*" />
              </td>
            </tr>
            <tr className="space">
              <td colSpan={3}></td>
            </tr>
          </table>
          <br />
          <hr />
          <div className="reset-addPetBreed-button">
            <button style={{ backgroundColor: "#F15843", color: "white" }}>
              Reset
            </button>
            <button
              type="submit"
              onClick={handleSubmit}
              style={{
                marginRight: "10px",
                backgroundColor: "#5B489D",
                color: "white",
              }}
            >
              Save
            </button>
          </div>
        </div>
      </div>
      <br />
    </div>
  );
};

export default AddPetBreed;
